@import '../variables';
@import "../modules/containers";
@import 'common/scss/styles';
@import '../_common-elements';

$xxs-breakpoint: 575px;

:root {
    --primary-color: #FF5F25;
    --text-color: #5B6B70;
    --success-color: #7DD006;
    --container-padding: 70px;
    --image-width: 450px;

    @media (max-width: $xs-breakpoint) {
        --container-padding: 4rem;
    }
}


html {
    scroll-behavior: smooth;
}

.section {
    h1 {
        font: 400 2.5rem/2.5rem $Exo-two;
        color: var(--primary-color);
    }

    .gray-title {
        font: 600 2.25rem/2.75rem $Exo;
        letter-spacing: -2%;
        text-align: center;
    }

    .orange-title {
        font: 700 1.5rem/1.875rem $Exo-two;
        color: var(--primary-color);
    }
    p {
        font: 400 1.125rem/27px $Open-Sans;
        color: var(--text-color);
    }

    @media (max-width: $xs-breakpoint) {
        h1, .orange-title {
            text-align: center;
        }
    }

    .container {
        display: flex;
        align-items: flex-start;

        &.two-col {
            align-items: center;

            @media (max-width: $medium-breakpoint) {
                flex-direction: column;

                &.md-reverse {
                    flex-direction: column-reverse;
                }
            }
        }
    }
    @media (max-width: $xxs-breakpoint) {
        .container {
            &.p15, .p15 {
                padding-left: 1rem;
                padding-right: 1rem;
            }
        }
    }

}

.supermicro-section {
    scroll-margin-top: 60px;
}

.head-box {
    display: flex;
    gap: 100px;
    justify-content: center;
    width: 100%;
    align-items: flex-end;
    padding: var(--container-padding) 0;

    .left {
        max-width: 500px;
        gap: 1.5rem;
        align-items: flex-start;
    }

    .right {
        min-width: var(--image-width);
        gap: 2rem;
        flex-shrink: 0;

        .main-img {
            width: 100%;
            height: auto;
            object-fit: cover;
            max-width: var(--image-width);
        }

        .partners {
            display: flex;
            gap: 0.6rem;
            justify-content: center;
        }
    }

    @media (max-width: $sm-breakpoint){
        flex-direction: column-reverse;
        align-items: center;
    }

    @media (max-width: $xs-breakpoint){
        gap: 4rem;

        min-width: auto;
        align-items: center;

        .right {
            min-width: auto;
        }
    }
}

.btn-box {
    display: flex;
    flex-wrap: wrap;
    gap: 1.5rem;
}


.highlights {
    background-color: var(--bg-modal-color);
    position: relative;
    text-align: center;
    padding: var(--container-padding) 0;
    min-height: 410px;

    &:before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 115px;
        background: linear-gradient(180deg, #E9EEF1 0%, rgba(233, 238, 241, 0) 100%);
        z-index: -1;
    }

    .list {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: flex-start;
        gap: 60px 1.25rem;
        margin-top: 50px;

        li {
            flex: 0 1 calc(25% - 1rem);
            gap: 1rem;
            min-width: 300px;
        }

        strong {
            display: block;
            font: 600 1.25rem/30px $Open-Sans;
            margin-top: 1rem;
            text-align: center;
        }

        p {
            font: 400 1rem/24px $Open-Sans;
            text-align: center;
        }

        @media (max-width: $xs-breakpoint){
            gap: 2rem 1.25rem;
            margin-top: 1.4rem;
        }
    }

}


.grey-section {
    background: #F9F9F9;
}

.flex-col-center {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.flex-col {
    display: flex;
    flex-direction: column;
}


.btn {
    color: #ffffff;
    font: 700 1.125rem/1.875rem $Exo;
    letter-spacing: -0.02em;
    text-align: center;
    min-width: 234px;
    padding: 7.5px 1.8rem;
}
.btn-primary {
    background-color: var(--primary-color);
}
.btn-success {
    background-color: var(--success-color);
}

.text-center {
    text-align: center;
}


.list-icons > li {
    padding-left: 1.5rem;
    position: relative;
    line-height: 1.5rem;
    margin-top: 1rem;
}


.two-col {
    display: flex;
    gap: 3rem 80px;
    padding: var(--container-padding) 0;

    @media (max-width: $sm-breakpoint){
        flex-wrap: wrap;
    }

    img {
        width: var(--image-width);
        object-fit: cover;
        flex-shrink: 0;
        height: auto;
        transition: transform .5s;
        touch-action: manipulation;

        @media (any-hover: hover) {
            &:hover {
                transform: translateY(-5px);
            }
        }
        &:active {
            transform: translateY(-5px);
        }
    }

    @media (max-width: $xs-breakpoint){
        padding: var(--container-padding) 0;

        img {
            width: 95%;
            max-width: 400px;
        }
    }
}

.text-box {
    flex-grow: 1;
    gap: 1.25rem;

    //.btn-box {
    //    flex-wrap: nowrap;
    //}

    h4 {
        font: 700 1.125rem/27px $Open-Sans;
    }
}

.mt-20 {
    margin-top: 20px;
}
.ml-40 {
    margin-left: 40px;

    @media (max-width: $sm-breakpoint){
        margin-left: 0;
    }
}


.inc-hover {
    transition: transform .5s;

        &:hover {
        transform: scale(1.1);
    }
}

.discover {
    .container {
        gap: 2rem;
        align-items: center;
        padding: var(--container-padding) 0;
    }
}

.additional-servers-box {
    display: flex;
    gap: 34px;
    width: 100%;

    .server-item {
        flex: 0 1 calc(33% - 1.5rem);
        background-color: #FFFFFF;
        transition: transform .5s;

        .top {
            border: 1px solid #E9EEF1;
            padding: 1.5rem 2.5rem 2.5rem;
            gap: 2.6rem;
            flex-grow: 1;
            justify-content: space-between;
        }

        .title {
            color: var(--primary-color);
            font: 600 1.125rem/1.25rem $Exo;
            text-align: center;
        }

        img {
            width: 100%;
            height: auto;
            object-fit: cover;
        }

        .btn-box {
            width: 100%;
            background-color: #E9EEF1;
            padding: 1.5rem ;
            flex-direction: column;
            gap: 0.8rem;

            .btn {
                width: 100%;
                min-width: auto;
            }
        }

            &:hover {
                transform: scale(1.05);
                box-shadow: 0 0 10px #E9EEF1;
        }
    }

    @media (max-width: $sm-breakpoint){
        gap: 1rem;

        .btn {
            font-size: 0.9rem;
            padding: 5px;
        }
    }

    @media (max-width: $xs-breakpoint){
        gap: 1rem;
        flex-wrap: wrap;
        justify-content: center;

        .server-item {
            flex: 0 1 calc(50% - 0.5rem);
        }
    }

    @media (max-width: $xxs-breakpoint) {
        gap: 3rem;

        .server-item {
            flex: 0 1 90%;
            max-width: 300px;
        }

        .btn {
            font-size: 1rem;
        }
    }
}

